import { t as translate } from "../../i18n/i18n.ts";

/** `wiki.reviewAfterDays` bounds (the server's schema): off, or this many days. */
export const REVIEW_DAYS_MIN = 30;
export const REVIEW_DAYS_MAX = 1825;

/** "Off", or "180 days". */
export function describeReviewPeriod(value: unknown): string {
  return typeof value === "number"
    ? translate("settings.behaviour.web.days", { count: value })
    : translate("settings.behaviour.off");
}
